// Module
var code = `<div class="js-products-document-main">
    <div class="js-products-document-top">
        <terceraLabel text="{{.text_top}}" additionalClass="js-label-document-top"/>
    </div>
    
    <div class="js-products-document-middle">
        <div class="js-label-document-middle">{{{text_middle}}}</div>
    </div>
    
    <div class="js-products-document-bottom">
        {{#if .stepsCount > 1}}
            <StepProgressBar numberOfSteps="{{stepsCount}}" currentStep="{{currentStep}}"/>
        {{/if}}
        <div class="js-products-document-buttons-bar">
            {{#if .currentStep !== 1}}
                <terceraButton  name="ArrowLeft" SVG="true"
                                terceraButtonStyle="back-button" text="{{.backButtonText}}" on-btnClick="backClick" />
            {{/if}}
            {{#if .currentStep !== .stepsCount}}
                <terceraButton  name="ArrowRight" SVG="true"
                                terceraButtonStyle="next-button" enabled="{{.canEnabledBTN}}" 
                                tooltip="{{.btnTooltip}}" text="{{.nextButtonText}}" on-btnClick="nextClick" />
            {{else}}
                <terceraButton  terceraButtonStyle="next-button" enabled="{{.canEnabledBTN}}" 
                                tooltip="{{.btnTooltip}}" text="{{.doneButtonText}}" on-btnClick="doneClick" />
            {{/if}}
        </div>
    </div>
</div>
`;
// Exports
export default code;